import { Link } from "react-router-dom";
import { ArrowUpRight, HeartHandshake } from "lucide-react";
import { Reveal, Eyebrow } from "./primitives";

export const SupportSection = () => (
    <section id="support" data-testid="support-section" className="scroll-mt-24 bg-[#F2EFE7] py-24 sm:py-32">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
            <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
                <div className="lg:col-span-5">
                    <Reveal>
                        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#1A3B2B] text-[#D9B96A]">
                            <HeartHandshake size={24} aria-hidden="true" />
                        </span>
                        <Eyebrow className="mt-6">Support Our Work</Eyebrow>
                        <h2 className="font-display mt-4 text-3xl font-medium tracking-tight text-[#0A1711] sm:text-4xl">
                            Support GGH 🌍
                        </h2>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <blockquote className="mt-8 border-l-2 border-[#C2A160] pl-6">
                            <p className="font-display text-xl italic leading-relaxed text-[#1A3B2B] md:text-2xl">
                                “Together, we can help turn better ideas into measurable impact.”
                            </p>
                        </blockquote>
                    </Reveal>
                </div>
                <div className="lg:col-span-7">
                    <Reveal delay={0.1}>
                        <p className="text-base leading-relaxed text-[#4A5D54] md:text-lg">
                            Help us build a more sustainable and regenerative future for
                            hospitality. Support for Global Green Hotel helps advance research,
                            educational resources, pilot initiatives, industry collaboration, and
                            practical solutions that can help hospitality businesses create
                            positive environmental, community, and business impact.
                        </p>
                        <p className="mt-5 text-base leading-relaxed text-[#4A5D54] md:text-lg">
                            There are many ways to contribute—share your expertise, participate in
                            research, become a partner, join a pilot initiative, or provide
                            financial support.
                        </p>
                    </Reveal>
                    <Reveal delay={0.25}>
                        <div className="mt-9 flex flex-wrap gap-4">
                            <Link to="/contact" data-testid="support-cta" className="btn-gold">
                                Support GGH
                                <ArrowUpRight size={16} aria-hidden="true" />
                            </Link>
                            <Link to="/partners" data-testid="support-partner-cta" className="btn-outline-green">
                                Partner With Us
                            </Link>
                        </div>
                        <p className="mt-6 max-w-xl text-xs leading-relaxed text-[#4A5D54]">
                            Financial contributions to GGH are voluntary. GGH does not currently
                            represent contributions as charitable or tax-deductible.
                        </p>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);
